import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Icon, Modal} from "antd"
import Clipboard from 'react-clipboard.js'

class BatchPartner extends Component {
    state = {
        textButton: 'Copy'
    }

    _onSuccess = () => {
        this.setState({
            textButton: 'Copied'
        })
    }

    render() {
        const {isOpen, urlBatchPartner, showModal} = this.props

        return (
            <div className="BatchPartner">
                <Modal
                    title="Địa chỉ lô được chia sẻ"
                    visible={isOpen}
                    onCancel={showModal}
                    footer={[
                        <Button key="back" onClick={showModal}>
                            Đóng
                        </Button>
                    ]}
                >
                    <div className="d-flex">
                        <p>{urlBatchPartner}</p>
                        <Clipboard data-clipboard-text={urlBatchPartner} className="ant-btn ant-btn-success ant-btn-primary"
                                   onSuccess={this._onSuccess}>
                            <Icon type="copy"/> {this.state.textButton}
                        </Clipboard>
                    </div>
                </Modal>
            </div>
        )
    }
}

BatchPartner.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    urlBatchPartner: PropTypes.string,
    showModal: PropTypes.func.isRequired
}

export default BatchPartner